import { createSelector } from 'reselect'
import { PeopleContactsState } from 'src/app/PeopleContacts/redux/peopleContacts.reducer'
import { RootState } from 'src/redux/createRootReducer'
import { selectContactsListModelsFromState } from 'src/redux/selectors/data/contacts.selectors'

export const selectPeopleContacts = (state: RootState): PeopleContactsState =>
  state.app.people.peopleContacts

export const selectPeopleContactsLoadingFromState = (
  state: RootState,
): boolean => state.app.people.peopleContacts.loading

export const selectPeopleContactsRemovingFromState = (
  state: RootState,
): boolean => state.app.people.peopleContacts.removing

export const selectNumberOfContactsFromState = (state: RootState): number =>
  state.app.people.peopleContacts.totalItems || 0

export const selectUniquePeopleContactIds = createSelector(
  [selectPeopleContacts],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)

export const selectUniquePeopleListModels = createSelector(
  [selectUniquePeopleContactIds, selectContactsListModelsFromState],
  (ids, contacts) => {
    return ids.map((id) => contacts[id]).filter((id) => id !== undefined)
  },
)

export const selectFilteredPeopleContacts = createSelector(
  [selectUniquePeopleListModels],
  (people) => people.filter(() => true),
)
